import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";

var SMTimePicker = function SMTimePicker(_ref) {
  var format = _ref.format,
      label = _ref.label,
      id = _ref.id,
      margin = _ref.margin,
      variant = _ref.variant,
      field = _ref.field,
      disableToolbar = _ref.disableToolbar,
      form = _ref.form,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      time = _ref.time,
      ampm = _ref.ampm,
      other = _objectWithoutProperties(_ref, ["format", "label", "id", "margin", "variant", "field", "disableToolbar", "form", "disablePast", "disableFuture", "time", "ampm"]);

  // const [ selectedDate, setDate ] = useState(new Date());
  // const handleChange = (date) => {
  // 	console.log(date);
  // 	setDate(date);
  // };
  return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils,
    locale: "es"
  }, /*#__PURE__*/React.createElement(KeyboardTimePicker, Object.assign({
    margin: margin,
    variant: variant,
    label: label,
    value: field.value,
    ampm: ampm,
    onChange: function onChange(time) {
      return time && form.setFieldValue(field.name, time, true);
    },
    KeyboardButtonProps: {
      "aria-label": "change time"
    }
  }, other)));
};

SMTimePicker.defaultProps = {
  format: "DD/MM/YYYY",
  disabledToolbar: false,
  variant: "outlined",
  margin: "normal",
  ampm: false
};
export { SMTimePicker };